import React from 'react';


import Sangat from './components/flights/sangat';
import NavBar from './components/navBar';
import LoginPage from './components/login';
import PrivateRoute from './components/PrivateRoute';
import { createBrowserHistory } from 'history';
import { authenticationService } from './authenticationService';

import PendingUser from "./components/flights/pendingUser";
import SangatDetails from './components/flights/sangatDetails';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

let history = createBrowserHistory();

const Role = localStorage.getItem('userRole');

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: null,
      isAdmin: false
    };
  }

  componentDidMount() {
    authenticationService.currentUser.subscribe(x => this.setState({
      currentUser: x
    }));
  }

  logout() {
    authenticationService.logout();
    history.push('/login');
  }

  render() {

    const { currentUser, isAdmin } = this.state;

    return (
      <Router history={createBrowserHistory}>

        {currentUser &&
          <NavBar user={currentUser} logoutCallback={this.logout}></NavBar>
        }
        {!currentUser && <NavBar ></NavBar>}

        <br />
        <Route path="/" exact component={LoginPage} />
        <Route path="/pending-user" exact component={PendingUser} />
        <Route path="/pending-user/:id" component={SangatDetails} />
        <PrivateRoute path="/sangat" exact component={Sangat} />


      </Router>
    );
  }
}

export default App;
